import { render, staticRenderFns } from "./CarrierNew.vue?vue&type=template&id=29ec2e54&scoped=true&"
import script from "./CarrierNew.vue?vue&type=script&lang=js&"
export * from "./CarrierNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec2e54",
  null
  
)

export default component.exports